import { useQuery } from "@tanstack/react-query";
import { EventDetails } from "features/types";
import { get } from "services/http";

export const useFetchEventsQuery = () => {
  return useQuery(
    ["fetchEvents"],
    () => {
      return get({
        url: "/events",
      }) as Promise<EventDetails[]>;
    },
    {
      staleTime: Infinity,
    }
  );
};
export const useFetchEventByCodeQuery = (code: string) => {
  return useQuery(
    ["fetchEventByCode", code],
    () => {
      if (code) {
        return get({
          url: `/events/code/${code}`,
        }) as Promise<EventDetails>;
      }
    },
    {
      staleTime: Infinity,
    }
  );
};
